export default "__VITE_ASSET__Goc1Isb4__"